import React, { useState } from "react";
import { Container } from "react-bootstrap";
import ProjectCard from "./ProjectCards";
import Particle from "../Particle";
import "./Projects.css";
import SkillSwap from "../../Assets/Projects/SkillSwap.png";
import Sportify from "../../Assets/Projects/Sportify.jpeg";
import Doctor from "../../Assets/Projects/doctorwheel.jpg";
import Lord from "../../Assets/Projects/LordSDL.jpeg";
import Chatbot from "../../Assets/Projects/bot.jpeg";
import Arduino from "../../Assets/Projects/arduino.jpeg";
import Troc from "../../Assets/Projects/troc.jpeg";
import TerminalPortfolio from "../../Assets/Projects/TerminalPortfolio.jpeg";
import FactoryMobileApp from "../../Assets/Projects/FactoryMobileApp.jpeg";
import Karhabti from "../../Assets/Projects/Karhabti.jpeg";
import devops from "../../Assets/Projects/devops.jpg";
import Microservices from "../../Assets/Projects/microservice.jpeg"; 
import web3 from "../../Assets/Projects/talan-talent-web3.jpeg";
import Parkini from "../../Assets/Projects/Parkini.jpg";
import InternshipScraper from "../../Assets/Projects/Scrapper.jpeg"; 
import AIDashboard from "../../Assets/Projects/AIDashboard.jpeg"; 
import LicensePlateDetection from "../../Assets/Projects/LicensePlateDetection.jpeg";


// Project data with category tags
const projects = [
  // {
  //   imgPath: SentinelX,
  //   title: "SentinelX - Industrial IoT Diagnostic Platform",
  //   description:
  //     "Next-generation industrial monitoring platform with 29 microservices, featuring Apache Flink 2.0 stream processing, River ML online learning, React 19 + ECharts (60 FPS), FastAPI Gateway, WebSocket real-time updates, SPIRE security, and comprehensive observability. Production-ready deployment with Kubernetes, Docker Compose, and full CI/CD pipeline.",
  //   ghLink: "https://github.com/marwaniiwael18/SentinelX-Diagnostic-Platform",
  //   demoLink: "https://pda-frequency-cooler-herb.trycloudflare.com",
  //   categories: ["iot", "backend", "web", "devops", "microservices", "ai", "machine learning"]
  // },
  // {
  //   imgPath: DiagNet,
  //   title: "DiagNet - Industrial IoT Microservices Platform",
  //   description:
  //     "Production-grade microservices platform for real-time industrial machine monitoring and predictive maintenance. Built with Spring Boot 3, React 18, TimescaleDB, MQTT, featuring JWT authentication, anomaly detection algorithms, and full observability with Prometheus & Grafana. Includes CI/CD pipeline with automated testing and security scanning.",
  //   ghLink: "https://github.com/marwaniiwael18/Diagnet-microservices-platform",
  //   categories: ["iot", "backend", "web", "devops", "microservices"]
  // },
  {
    imgPath: SkillSwap,
    title: "SkillSwap - AWS Full-Stack Application",
    description:
      "A modern skill-sharing platform built with React and Node.js, deployed on AWS serverless infrastructure. Features AWS Cognito authentication, DynamoDB, Lambda functions, S3 hosting, and professional CI/CD pipeline with GitHub Actions.",
    ghLink: "https://github.com/marwaniiwael18/AWS-App",
    demoLink: "http://skillswap-frontend-prod.s3-website.eu-north-1.amazonaws.com",
    categories: ["web", "aws", "backend", "devops", "ai"]
  },
  {
    imgPath: AIDashboard,
    title: "Smart Parking AI Dashboard",
    description:
      "A machine learning system that predicts parking duration and space occupancy using regression and classification models. Built with Flask, React, and scikit-learn, featuring interactive visualizations and real-time predictions deployed on Render.",
    ghLink: "https://github.com/marwaniiwael18/Ai-Dashboard-Ml-Parkini",
    demoLink: "https://parkini-smart-dashboard-qd80.onrender.com/",
    categories: ["ai", "web", "python", "machine learning"]
  },
  {
    imgPath: LicensePlateDetection,
    title: "License Plate Detection System",
    description:
      "A real-time license plate detection system using OpenCV and EasyOCR that captures plates from a webcam feed, detects them using Haar Cascades, and extracts plate numbers with OCR technology. Specialized for Arabic text detection.",
    ghLink: "https://github.com/marwaniiwael18/Car-Number-Plates-Detection-IA-Model-",
    ytLink: "https://www.linkedin.com/posts/wael-marwani-_deeplearning-computervision-ai-activity-7321535472181096450-8bLt?utm_source=share&utm_medium=member_desktop&rcm=ACoAADTffyoBWZSdsSvKW9JfnrzTolT3l9OEdAQ",
    categories: ["ai", "python", "deep learning", "computer vision"]
  },
  {
    imgPath: InternshipScraper,
    title: "IT Engineering Internship Scraper",
    description:
      "A specialized automation tool that scrapes IT engineering internships across Europe and delivers them directly to Telegram. Features enhanced filtering for tech positions, 3-day freshness filter, and 24/7 deployment on Replit with a web dashboard.",
    ghLink: "https://github.com/marwaniiwael18/Internship-Scraper",
    demoLink: "https://4aaefa99-44bb-40a8-9b9c-aafaf1170a94-00-i4jle1pdkko9.riker.replit.dev/",
    categories: ["automation", "web", "python"]
  },
  {
    imgPath: Parkini,
    title: "Parkini - Smart Parking System",
    description:
      "Parkini is a smart parking web app using React, Node.js, MongoDB, AI, and face recognition. It allows users to reserve spots with QR codes, detect intrusions via license plate scanning, and track usage with Grafana & Prometheus.",
    demoLink: "https://front-end-front-office.vercel.app",
    ytLink: "https://www.youtube.com/watch?v=eoB50txFe9Q&ab_channel=WaelMarouanii",
    categories: ["web", "ai"]
  },  
  {
    imgPath: Microservices,
    title: "Microservices - Restaurant Complaints",
    description:
      "A distributed web app for managing restaurant complaints, using Angular, Spring Boot microservices, Kafka for messaging, and MySQL, deployed with Docker Compose.",
    ghLink: "https://github.com/marwaniiwael18/Application_Web_Distibue",
    categories: ["web", "backend"]
  },
  {
    imgPath: devops,
    title: "DevOps Pipeline - Ski Station Management",
    description:
      "An end-to-end DevOps pipeline for a ski station management system using Spring Boot, showcasing CI/CD with Jenkins, Docker, Nexus, SonarQube, Prometheus, and Grafana.",
    ghLink: "https://github.com/marwaniiwael18/DEVOPS-Project",
    categories: ["devops", "backend"]
  },
  {
    imgPath: web3,
    title: "Talan Talent Web3 - NFT Talent Showcase",
    description:
      "A full-stack dApp where users mint NFTs representing their hidden talents (music, art, coding, etc.), built with React, Solidity, Hardhat, and MetaMask integration, with assets stored on IPFS via Pinata.",
    ghLink: "https://github.com/marwaniiwael18/talan-talent-web3",
    categories: ["web3", "web"]
  },  
  {
    imgPath: Karhabti,
    title: "Karhabti - Car Rental Web Application",
    description:
      "A web application for car rental developed using React JSX for the front end and React TSX for the admin dashboard.",
    demoLink: "https://karhabti.vercel.app/",
    categories: ["web"]
  },
  {
    imgPath: FactoryMobileApp,
    title: "Factory Mobile App - Hackathon Project",
    description:
      "An innovative mobile app developed in a 24-hour hackathon, monitoring cement prices and integrating real-time GPS verification.",
    ghLink: "https://github.com/marwaniiwael18/Application-Mobile-HACKATHON-",
    ytLink: "https://www.youtube.com/watch?v=oYuL_l5qsUA",
    categories: ["mobile"]
  },
  {
    imgPath: TerminalPortfolio,
    title: "Terminal Portfolio",
    description:
      "An interactive portfolio terminal showcasing skills, projects, and background in an engaging terminal-style interface.",
    ghLink: "https://github.com/marwaniiwael18/Terminal-Portfolio",
    demoLink: "https://terminal-portfolio-lake.vercel.app/",
    categories: ["web"]
  },
  {
    imgPath: Arduino,
    title: "Arduino project",
    description:
      "A UI built using Squareline Studio, demonstrating graphical UI editing for various projects.",
    ghLink: "https://github.com/marwaniiwael18/Squareline-Studio-UI-Project",
    categories: ["iot"]
  },
  {
    imgPath: Chatbot,
    title: "Chatbot",
    description:
      "A chatbot system encapsulating best practices and innovative methodologies.",
    ghLink: "https://github.com/marwaniiwael18/chetbot_masterclass-main",
    categories: ["ai"]
  },
  {
    imgPath: Sportify,
    title: "Sportify",
    description:
      "Sportify is a web & desktop app built using Symfony 5.4 & JavaFX for sports ground reservations.",
    ghLink: "https://github.com/marwaniiwael18/Sportify",
    categories: ["web", "desktop"]
  },
  {
    imgPath: Doctor,
    title: "Doctor Wheel",
    description:
      "A desktop application in C++ with QT Creator, managing vehicle technical visits.",
    ghLink: "https://github.com/marwaniiwael18/Doctor-Wheel",
    categories: ["desktop"]
  },
  {
    imgPath: Troc,
    title: "TUNI-TROC",
    description:
      "A web platform for selling, exchanging, or donating furniture, built using PHP, JavaScript, and an Oracle database.",
    ghLink: "https://github.com/marwaniiwael18/Tuni-Troc",
    ytLink: "https://www.youtube.com/watch?v=kSqzBMO20GU",
    categories: ["web"]
  },
  {
    imgPath: Lord,
    title: "Lord Of Amazigh",
    description:
      "A 2D game developed in C using the SDL library, showcasing video game development skills.",
    ghLink: "https://github.com/marwaniiwael18/SDL-Project-Jeu.2D?tab=readme-ov-file",
    categories: ["game"]
  },
];

function Projects() {
  const [filteredProjects, setFilteredProjects] = useState(projects);
  const [activeFilter, setActiveFilter] = useState("all");
  const [fadeIn, setFadeIn] = useState(true);
  const [isAnimating, setIsAnimating] = useState(false);

  // Extract all unique categories and count projects in each
  const getCategoryCounts = () => {
    const counts = { all: projects.length };
    
    // Flatten all categories and count occurrences
    projects.forEach(project => {
      project.categories.forEach(category => {
        counts[category] = (counts[category] || 0) + 1;
      });
    });
    
    return counts;
  };

  // Categories with counts
  const categoryCounts = getCategoryCounts();
  
  // List of categories with "all" first, then sorted by count (descending)
  const categories = ["all", ...Object.keys(categoryCounts)
    .filter(cat => cat !== "all")
    .sort((a, b) => categoryCounts[b] - categoryCounts[a])];

  // Filter projects based on category
  const handleFilterClick = (category) => {
    if (isAnimating || category === activeFilter) return;
    
    setIsAnimating(true);
    setFadeIn(false);
    
    setTimeout(() => {
      if (category === "all") {
        setFilteredProjects(projects);
      } else {
        const filtered = projects.filter(project => project.categories.includes(category));
        setFilteredProjects(filtered);
      }
      setActiveFilter(category);
      setFadeIn(true);
      
      setTimeout(() => {
        setIsAnimating(false);
      }, 300);
    }, 300);
  };

  return (
    <Container fluid className="project-section">
      <Particle />
      <Container>
        <h1 className="project-heading">
          My Creative <strong className="purple">Portfolio</strong>
        </h1>
        <p className="text-center mb-5" style={{ color: "#8d8d8d" }}>
          Here are some of the projects I've worked on
        </p>
        
        {/* Category Filter Buttons */}
        <div className="filter-container">
          {categories.map((category, index) => (
            <button
              key={index}
              onClick={() => handleFilterClick(category)}
              className={`filter-btn ${activeFilter === category ? "active" : ""}`}
              disabled={isAnimating}
            >
              {category}
              <span className="project-count">{categoryCounts[category] || 0}</span>
            </button>
          ))}
        </div>
        
        {/* Projects Grid */}
        <div 
          className="portfolio-container"
          style={{ 
            opacity: fadeIn ? 1 : 0,
            transform: fadeIn ? 'translateY(0)' : 'translateY(20px)',
            transition: "all 0.5s ease-in-out"
          }}
        >
          {filteredProjects.map((project, index) => (
            <ProjectCard
              key={index}
              imgPath={project.imgPath}
              title={project.title}
              description={project.description}
              ghLink={project.ghLink}
              demoLink={project.demoLink}
              ytLink={project.ytLink}
            />
          ))}
        </div>
        
        {filteredProjects.length === 0 && (
          <p className="text-center mt-5" style={{ color: "#8d8d8d" }}>
            No projects found in this category.
          </p>
        )}
      </Container>
    </Container>
  );
}

export default Projects;
